import { applyFacets, updateMultiFacet } from "../modules/search";

const DEBOUNCE_MS = 250;

export const facetDebounceMiddleware = (store) => {
  let timer = null;
  let pending = [];

  const flush = () => {
    pending = [];
    timer = null;
    store.dispatch(applyFacets({ keepSelections: true }));
  };

  return (next) => (action) => {
    if (action.type === updateMultiFacet.type) {
      if (action.meta?.skipDebounce) {
        return next(action);
      }

      const payloadArray = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];

      const originalToggles = action.meta && action.meta.originalToggles;
      pending = pending.concat(originalToggles || payloadArray);
      if (timer) clearTimeout(timer);
      timer = setTimeout(flush, DEBOUNCE_MS);
    }

    return next(action);
  };
};

export default facetDebounceMiddleware;
